module.exports = __webpack_public_path__ + "static/media/5.84ce89d1.jpg";